// Static text + config for the Swap Curve widget. No JSX — keep as .ts.

// Centered message shown when a trade is added (via dropdown or drag-drop) that
// does not contain any swap blocks.
export const ONLY_SWAP_TRADES_MESSAGE =
  "Only trades that contain a swap can be added to the Swap Curve.";

// Centered message shown when a Creation block is dropped that is not a swap.
export const ONLY_SWAP_BLOCKS_MESSAGE =
  "Only blocks that are swaps can be added to the Swap Curve.";

// Centered message shown when a trade the user did not originate (RP side) is added.
// Curve data is only available for trades the user originated (OP side).
export const ONLY_ORIGINATED_TRADES_MESSAGE =
  "Only trades you have originated can show curves.";

// Placeholder for the trade selector dropdown.
export const SWAP_CURVE_DROPDOWN_PLACEHOLDER = "Select a swap trade ...";

// Hint shown in the centre of the widget before anything has been added.
export const SWAP_CURVE_EMPTY_HINT =
  "Drop a swap trade from the Blotter or a swap block from Trade Creation, or pick a trade above.";
